// ProtectedAccountSettings.js
import React from 'react';
import withAuth from './withAuth';
import AccountSettings from './AccountSettings';

const ProtectedAccountSettings = withAuth(AccountSettings);

export default ProtectedAccountSettings;
